export default "<select-one [schema]=\"schema\"></select-one>";